var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActicsLeftMenu',{scopedSlots:_vm._u([{key:"app",fn:function(){return [_c('router-link',{staticClass:"p-3",attrs:{"to":{ name: 'callPlanning' }}},[_c('span',{staticClass:"nexa-black extra-bold"},[_vm._v("C")]),_c('span',{staticClass:"nexa-regular"},[_vm._v("P")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }